import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Logout = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.49601 5.15227C5.69127 5.34753 5.69127 5.66411 5.49601 5.85938L3.85531 7.50008L10.5077 7.5C10.7838 7.5 11.0077 7.72386 11.0077 8C11.0077 8.27614 10.7838 8.5 10.5077 8.5L3.84382 8.50008L5.49601 10.1523C5.69127 10.3475 5.69127 10.6641 5.49601 10.8594C5.30075 11.0546 4.98416 11.0546 4.7889 10.8594L2.2889 8.35938C2.09364 8.16411 2.09364 7.84753 2.2889 7.65227L4.7889 5.15227C4.98417 4.95701 5.30075 4.95701 5.49601 5.15227ZM7.99986 13C7.72372 13 7.49986 13.2239 7.49986 13.5C7.49986 13.7761 7.72372 14 7.99986 14L13.0232 14C13.2994 14 13.5232 13.7761 13.5232 13.5L13.5232 2.5C13.5232 2.22386 13.2994 2 13.0232 2L7.99986 2C7.72372 2 7.49986 2.22386 7.49986 2.5C7.49986 2.77614 7.72372 3 7.99986 3L12.5232 3L12.5232 13L7.99986 13Z"
        fill={color}
      />
    </svg>
  )
})

export default Logout
